// extracted by mini-css-extract-plugin
module.exports = {"ModalWidth":"Tags_ModalWidth__KWubx","TotalHourField":"Tags_TotalHourField__25Z4T"};